import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  PatchFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  FpxIHttpOption
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Schedulerep, SchedulerepMaintanence } from './schedulerep.model';
import { environment } from 'src/environments/environment';
@Injectable()
export class SchedulerepService implements BaseFpxDataService<any> {
 constructor(private _httpProvider : HttpProviderService) { }
  create(payload: Schedulerep,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/schedulerep');
      let bodyContent = {"schedulerep":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
 
  findByKey(key: Schedulerep,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindByKeyFn<Schedulerep|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/schedulerep/{scheduleId}');
       httpRequest.addPathParameter('scheduleId', key.scheduleId);
       httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.schedulerep ?? null),catchError((err:any) => {
              return of(null)
            }));
        
    };
  }

  modify(payload: Schedulerep,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/schedulerep/{scheduleId}');
       httpRequest.addPathParameter('scheduleId', payload.scheduleId);
     httpRequest.setMethod('PUT');
      let bodyContent = {"schedulerep":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
  
   delete(payload: Schedulerep,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/schedulerep/{scheduleId}');
       httpRequest.addPathParameter('scheduleId', payload.scheduleId);
     httpRequest.setMethod('DELETE');
      let bodyContent = {"schedulerep":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
  
   patch(payload: Schedulerep,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): PatchFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/schedulerep/{scheduleId}');
       httpRequest.addPathParameter('scheduleId', payload.scheduleId);
     httpRequest.setMethod('PUT');
      let bodyContent = {"schedulerep":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest,httpOption);
    };
  }
   findAll(criteriaQuery: CriteriaQuery,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<SchedulerepMaintanence> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/schedulerep');
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setMethod('GET');
      httpRequest.addQueryParameter('serviceCode',criteriaQuery.getQueryparam('serviceCode'));
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(
          map(
            (res: IHttpSuccessPayload<SchedulerepMaintanence>) =>{
             return{
              data:res.body?.schedulerep || [],
              totalRowCount: res.body?.totalRowCount
              }
            }
          )
        );
    };
  }

  lookup(key: any,httpOption : Map<keyof FpxIHttpOption, Map<string, any>> = new Map(), criteriaQuery?: CriteriaQuery | undefined): LookUpFn<any> {
    return () => {
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource('/schedulerep');
    httpRequest.addQueryParameter('lookup', 1);
    if(criteriaQuery){
        criteriaQuery?.addFilterCritertia('text','String','Contains',{
          searchText : key.searchText
        })
        httpRequest.setCriteriaQuery(criteriaQuery)
     }
    return this._httpProvider.invokeRestApi(httpRequest,httpOption).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data || [];
        })
      );
    };
  }
  fetchStatistics(criteriaQuery: CriteriaQuery,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource("/schedulerep/statistics");
      httpRequest.setMethod("GET");
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body));
    };
  }
  
}
